import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosClient, getBaseUrlVersioned } from "../../services/axiosClient";
const conversationRulebookUrl = (conversationId) => `${getBaseUrlVersioned(null)}/conversations/${encodeURIComponent(conversationId)}/rulebook`;
/**
 * Pins one of the user's Rulebooks onto the conversation (`PATCH /conversations/{id}/rulebook` with `rulebook_id`).
 * One-time: the server answers 409 once the conversation has a pin, which its first evaluated turn also sets. The
 * response carries `rulebook_hud`, so the HUD switches to the pinned Rulebook with no extra fetch.
 */
export const pinConversationRulebook = createAsyncThunk("rulebook/pinConversationRulebook", async ({ conversationId, rulebookId }, thunkAPI) => {
    try {
        const response = await axiosClient.patch(conversationRulebookUrl(conversationId), {
            rulebook_id: rulebookId,
        });
        return { conversationId, rulebookHud: response.data.rulebook_hud ?? null };
    }
    catch (error) {
        throw thunkAPI.rejectWithValue(error?.response?.data);
    }
});
/** The rulebook slice's reducers for the conversation's resolved Rulebook and its pin. */
export function addConversationRulebookCases(builder) {
    builder.addCase(pinConversationRulebook.fulfilled, (state, action) => {
        const { conversationId, rulebookHud } = action.payload;
        const { rulebookId } = action.meta.arg;
        state.settingsByConversationId[conversationId] = { ...state.settingsByConversationId[conversationId], rulebook_id: rulebookId };
        state.byConversationId[conversationId] = rulebookHud?.rulebook ?? null;
        state.initialStateByConversationId[conversationId] = rulebookHud?.initial_state ?? null;
    });
}
